/**
 * @readonly
 * @typedef {Object} VehicleModelModel
 * @property {string} CONNECTED_CAR_MODEL_ID - The ID of the connected car model
 * @property {string} MODEL_ID - The ID of the model
 * @property {string} NAME - The vehicle's model name
 * @property {string} VARIANT - The vehicle's variant
 */
export const VehicleModelModel = {
    CONNECTED_CAR_MODEL_ID: 'connectedCarModelId',
    MODEL_ID: 'modelId',
    NAME: 'name',
    VARIANT: 'variant'
}
